import { getWordpressVars } from "@lib/wordpressVars";
import { Col, Layout, Row, Spin } from "antd";
import { SingleHeader } from "@components/header";
import { useGetPostByIdQuery } from "@mwServices/Post";
import { DynamicBlock } from "@components/block";
import useScrollToLocation from "@hooks/useScrollToLocation";
import { useLocation } from "react-router-dom";
import ShareSocialMediaButtons from "@components/share-social-media-buttons";
import RelatedPosts from "@mwPartials/post/RelatedPosts";
import PostAuthors from "@mwPartials/post/PostAuthors";
import { ShowElements } from "@lib/constants";
import { SimplePagination } from "@components/simple-pagination";
import { sanitizeSearchInput } from "@lib/utils";
import { useWindowSize } from "@components/window-size-provider";
import { useGetHeaderAdsQuery } from "@mwServices/Ads";
import { useEffect, useState } from "react";
import { HeaderAd } from "@components/header-ad";

interface ReportProps {
    objectId?: number;
}

const defaultProps: ReportProps = {};

const Report = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(sanitizeSearchInput(location.search));
    const search = queryParams.get('search');
    const ID = getWordpressVars().ID;
    const ads = getWordpressVars().ads;
    const { isLargeScreen } = useWindowSize();

    const headerAdsQuery = useGetHeaderAdsQuery({ID});
    const [desktopHeaderAd, setDesktopHeaderAd] = useState<any>();
    const [mobileHeaderAd, setMobileHeaderAd] = useState<any>();
    useEffect(() => {
        if (headerAdsQuery.data) {
            headerAdsQuery.data.forEach((ad) => {
                if (ad.isMobile) {
                    setMobileHeaderAd(ad);
                } else {
                    setDesktopHeaderAd(ad);
                }
            });
        }
    }, [headerAdsQuery.data]);

    const {
        isLoading,
        data,
    } = useGetPostByIdQuery({ id: ID });

    useScrollToLocation();

    return (
        <Layout className="post-report">
            <Row className={`mar-bot-30`}>
                <Col span={24}>
                </Col>
            </Row>
            <Row justify={`center`} className={`mar-bot-30`}>
                <Col lg={22} xs={24}>
                    <Row
                        className={isLargeScreen ? 'grid-auto-350' : ''}
                        justify={`center`}
                        gutter={[30, 30]}
                    >
                        <Col className={`border-r-1-light-grey`}>
                            <Spin size="large" spinning={isLoading}>
                                {data?.showElements?.includes(ShowElements.PAGINATION_TOP)
                                    && <Row justify={"center"}>
                                        <Col lg={18} xs={23}>
                                            {data?.simplePagination && (
                                                <SimplePagination
                                                    next={data.simplePagination.next}
                                                    previous={data.simplePagination.previous}
                                                    className={`mar-bot-30`}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                }

                                {data?.showElements?.includes(ShowElements.HERO_HEADER)
                                    && <SingleHeader
                                        className={`subheader mar-bot-30`}
                                        imgSrc={`${data?.image?.src}`}
                                        focalPoint={data?.image?.focalPoint}
                                        parallax={false}
                                        justify="center"
                                        align="middle"
                                    />}
                                <Row className="content" justify={"center"}>
                                    {(isLargeScreen && desktopHeaderAd) &&
                                        <HeaderAd
                                            campaignUrl={desktopHeaderAd.campaignUrl}
                                            adId={desktopHeaderAd.adId}
                                            imageUrl={desktopHeaderAd.imageUrl}
                                            style={{marginBottom: '20px'}}
                                        />
                                    }
                                    {(!isLargeScreen && mobileHeaderAd) &&
                                        <HeaderAd
                                            campaignUrl={mobileHeaderAd.campaignUrl}
                                            adId={mobileHeaderAd.adId}
                                            imageUrl={mobileHeaderAd.imageUrl}
                                            style={{marginBottom: '20px'}}
                                        />
                                    }
                                    <Col lg={18} xs={23}>
                                        <h1 className="report-header">{data?.title}</h1>
                                        {data?.showElements?.includes(ShowElements.DATE)
                                            && <p className="report-lead">{data?.date}</p>}
                                    </Col>
                                    {data?.showElements?.includes(ShowElements.SHARE_BUTTONS)
                                        && <Col lg={18} xs={23}>
                                            {data?.socialShare
                                                && <ShareSocialMediaButtons
                                                    {...data.socialShare}
                                                />}
                                        </Col>
                                    }
                                    <Col lg={18} xs={23}>
                                        <DynamicBlock
                                            key={data?.ID}
                                            blocks={data?.blocks}
                                            search={search}
                                        />
                                    </Col>
                                </Row>
                                {data?.showElements?.includes(ShowElements.RELATED_POSTS)
                                    && <Row justify={"center"}>
                                        <Col lg={18} xs={23}>
                                            {data && (
                                                <>
                                                    <hr className="thin" />
                                                    <RelatedPosts attrs={{
                                                        tags: data?.taxonomy?.tags || [],
                                                        category: data?.taxonomy?.category || [],
                                                        taxonomies: ['post_tag', 'category'],
                                                        page: 1,
                                                        perPage: 2,
                                                    }} />
                                                </>
                                            )}
                                        </Col>
                                    </Row>}
                                {data?.showElements?.includes(ShowElements.AUTHORS)
                                    && <Row justify={"center"}>
                                        <Col lg={18} xs={23}>
                                            {data?.authors && (
                                                <PostAuthors className="border-top-thick" data={data?.authors} />
                                            )}
                                        </Col>
                                    </Row>
                                }
                                {data?.showElements?.includes(ShowElements.PAGINATION_BOTTOM)
                                    && <Row justify={"center"}>
                                        <Col lg={18} xs={23}>
                                            {data?.simplePagination && (
                                                <SimplePagination
                                                    justify={`end`}
                                                    next={data.simplePagination.next}
                                                    previous={data.simplePagination.previous}
                                                    className={`mar-top-30`}
                                                />
                                            )}
                                        </Col>
                                    </Row>
                                }
                            </Spin>
                        </Col>
                        <Col>
                            {ads && <DynamicBlock blocks={ads} />}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Layout >
    );
};

Report.defaultProps = defaultProps;

export default Report;
